export default "__VITE_PUBLIC_ASSET__a30124c1__"